module.exports = __webpack_public_path__ + "img/lose_lottery2_mall.bf2dd908.png";